import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.parse-int";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/*
 * ATTENTION!
 *
 * If you just want to track some events, please use `mp` from `helpers/multitrack`
 */
import PropTypes from 'prop-types';
import React from 'react';
import { readLocalStorage } from 'redux/saga/helpers/local-storage';
var MIXPANEL_DEBUG = false;
var MIXPANEL_INIT = "(function(f,b){if(!b.__SV){var a,e,i,g;window.mixpanel=b;b._i=[];b.init=function(a,e,d){function f(b,h){var a=h.split(\".\");2==a.length&&(b=b[a[0]],h=a[1]);b[h]=function(){b.push([h].concat(Array.prototype.slice.call(arguments,0)))}}var c=b;\"undefined\"!==typeof d?c=b[d]=[]:d=\"mixpanel\";c.people=c.people||[];c.toString=function(b){var a=\"mixpanel\";\"mixpanel\"!==d&&(a+=\".\"+d);b||(a+=\" (stub)\");return a};c.people.toString=function(){return c.toString(1)+\".people (stub)\"};i=\"disable track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config people.set people.set_once people.increment people.append people.union people.track_charge people.clear_charges people.delete_user\".split(\" \");\nfor(g=0;g<i.length;g++)f(c,i[g]);b._i.push([a,e,d])};b.__SV=1.2;a=f.createElement(\"script\");a.type=\"text/javascript\";a.async=!0;a.src=\"undefined\"!==typeof MIXPANEL_CUSTOM_LIB_URL?MIXPANEL_CUSTOM_LIB_URL:\"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js\";e=f.getElementsByTagName(\"script\")[0];e.parentNode.insertBefore(a,e)}})(document,window.mixpanel||[]);";
var mixpanelCheckTimer;
var mixpanelMethods = ['track', 'get_property', 'register', 'register_once', 'alias', 'identify'];
var mixpanelCalls = {};
var onReadyCalls = [];

function nativeMixpanel() {
  if (__CLIENT__ && window.mixpanel) {
    return window.mixpanel && window.mixpanel.__loaded ? window.mixpanel : null; // eslint-disable-line no-underscore-dangle
  }
}

function mixpanelCheck() {
  var mixpanel = nativeMixpanel();

  if (mixpanel) {
    clearInterval(mixpanelCheckTimer);
    onReadyCalls.forEach(function (func) {
      return func();
    });
    onReadyCalls.length = 0;
    mixpanelMethods.filter(function (method) {
      return mixpanelCalls[method] && mixpanelCalls[method].length > 0;
    }).forEach(function (method) {
      return mixpanelCalls[method].forEach(function (methodArguments) {
        return mixpanel[method].apply(mixpanel, _toConsumableArray(methodArguments));
      });
    });
    mixpanelMethods = {};
  }
}

var mixpanelInterface = mixpanelMethods.reduce(function (mpInterface, method) {
  mpInterface[method] = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (__CLIENT__ && readLocalStorage('trackingDebug')) {
      var _console;

      (_console = console).info.apply(_console, ["Tracking MixPanel.".concat(method)].concat(args)); // eslint-disable-line no-console

    }

    if (nativeMixpanel()) {
      var _nativeMixpanel;

      return (_nativeMixpanel = nativeMixpanel())[method].apply(_nativeMixpanel, args);
    }

    mixpanelCalls[method] = mixpanelCalls[method] || [];
    mixpanelCalls[method].push(args);

    if (!mixpanelCheckTimer && __CLIENT__) {
      mixpanelCheckTimer = setInterval(mixpanelCheck, 500);
    }
  };

  return mpInterface;
}, {});

mixpanelInterface.onReady = function (func) {
  if (nativeMixpanel()) {
    func();
  } else {
    onReadyCalls.push(func);

    if (!mixpanelCheckTimer && __CLIENT__) {
      mixpanelCheckTimer = setInterval(mixpanelCheck, 500);
    }
  }
};

export var mixpanel = mixpanelInterface;
export var MixPanel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MixPanel, _React$Component);

  function MixPanel() {
    _classCallCheck(this, MixPanel);

    return _possibleConstructorReturn(this, _getPrototypeOf(MixPanel).apply(this, arguments));
  }

  _createClass(MixPanel, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this = this;

      var _this$props = this.props,
          currentUser = _this$props.currentUser,
          msa = _this$props.msa,
          deviceType = _this$props.deviceType;

      if (__CLIENT__) {
        if (!currentUser) {
          var lastCheckTime;

          try {
            lastCheckTime = parseInt(window.localStorage.getItem('lastSessionStart') || 0, 10);
          } catch (err) {// NOOP to catch Safari private browsing
          }

          if (lastCheckTime < Date.now() - 60 * 1e3 * 30) {
            // every 30 minutes
            mixpanel.onReady(function () {
              _this.sessionStart();

              try {
                window.localStorage.setItem('lastSessionStart', Date.now());
              } catch (err) {// NOOP to catch Safari private browsing
              }
            });
          }
        }

        mixpanelInterface.register({
          user_type: mixpanelInterface.get_property('user_type') || 'prospect',
          msa_id: msa ? msa.id : mixpanelInterface.get_property('msa_id'),
          msa_name: msa ? msa.name : mixpanelInterface.get_property('msa_name'),
          app_platform: 'web',
          device_type: deviceType
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // Track a MP page view if the URL changes
      if (this.props.currentPath !== nextProps.currentPath) {
        mixpanel.track('mp_page_view', {
          mp_page: __CLIENT__ ? window.location.href : nextProps.currentPath
        });
      }
    }
  }, {
    key: "sessionStart",
    value: function sessionStart() {
      if (!this.props.routes) {
        return;
      }

      mixpanelInterface.register({
        session_start_count: (mixpanelInterface.get_property('session_start_count') || 0) + 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var accountKey = this.props.accountKey;
      var accountInit = "mixpanel.init('".concat(accountKey, "');");

      if (__LOCAL_DEV__ && MIXPANEL_DEBUG) {
        accountInit = "mixpanel.init('".concat(accountKey, "', { debug: true });");
      }

      return React.createElement("script", {
        key: "mixpanel-script" // eslint-disable-next-line react/no-danger
        ,
        dangerouslySetInnerHTML: {
          __html: (MIXPANEL_INIT + accountInit).replace(/\n/g, '')
        }
      });
    }
  }]);

  return MixPanel;
}(React.Component);
MixPanel.propTypes = {
  accountKey: PropTypes.string.isRequired,
  currentPath: PropTypes.string.isRequired,
  deviceType: PropTypes.string.isRequired,
  routes: PropTypes.array,
  msa: PropTypes.object,
  currentUser: PropTypes.object
};